<template>
  <div>
    <form v-if="msgType != 'success' || msgType === ''" method="post" class="search-zipcode-form" autocomplete="off" @submit.prevent="submitBlog()">
      <fieldset class="form-group">
        <label for="page-title">Page url</label>
        <select
                class="form-control"
                name="pageUrl"
                id="pageUrl"
                @change="handleState"
                :value="pageUrl"
                required
              >
               <option value="">Select page url</option>
                <option
                  v-for="option in pageUrls"
                  :key="option.url"
                  :value="option.url"
                  >{{ option.title }}</option
                >
              </select>
      </fieldset>
      
      <fieldset class="form-group">
        <label for="page-title">Page Title</label>
        <input id="page-title" class="form-control" type="text" v-model="pageTitle" name="pageTitle">
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-description">Meta Description</label>
        <input id="meta-description" class="form-control" type="text" v-model="metaDescription" name="metaDescription">
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-keywords">Meta Keywords (Separate keywords by comma)</label>
        <input id="meta-keywords" class="form-control" type="text" v-model="metaKeywords" name="metaKeywords">
      </fieldset>
      <button type="submit" class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
        :class="{ disabled: isDisabled }" :disabled="isDisabled">Save</button>

    </form>
    <div :class="['alert', msgType === 'success' ? 'alert-success' : msgType === 'error' ? 'alert-danger' : '']">
      <div>{{ msg }}</div>
    </div>


  </div>
</template>

<script>
import {
  createStatisticalMixin,
  statisticalStore
} from '@/mixins/statisticalMixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {
  createBlogMixin,
  blogsStore,
} from "@/mixins/blogsMixin";
import {
  modalStore,
} from "@/mixins/modalsMixin";
import localStorage from '@/utils/localStorage';
export default {
  name: 'VSeoForm',
  mixins: [createBlogMixin(), createStatisticalMixin()],
  data() {
    return {
      pageUrl: '',
      pageTitle: '',
      metaDescription: '',
      metaKeywords: '',
      isDisabled: false,
      msg: "",
      msgType: ""
    };
  },
  props: {
    seo: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleState(e){
      this.pageUrl = e.target.value
    },
    updatePostDate(event) {
      // Update the postDate when the user selects a new date
      const selectedDate = event.target.value;
      this.postDate = new Date(selectedDate).toISOString();
    },
    resetData() {
      this.pageUrl= '';
      this.pageTitle= '';
      this.metaDescription= '';
      this.metaKeywords= '';
    },
    async submitBlog() {
      const isUpdateReq = (this.$props.seo && this.$props.seo.id);
      try {
        this.isDisabled = true
        const seoObj = {
          pageUrl: this.pageUrl,
          pageTitle: this.pageTitle,
          metaDescription: this.metaDescription,
          metaKeywords: this.metaKeywords,
        };
        if (isUpdateReq) {
          const seoId = this.$props.seo.id;
          debugger
          await this[statisticalStore.actionTypes.ACTION_EDIT_SEO]({ seoId, seo: seoObj });
        } else {
          await this[statisticalStore.actionTypes.ACTION_ADD_SEO_PAGE](seoObj);
        }
        this.resetData();
        this.msgType = 'success';
        if(this.$props.seo.id){
          // this.msg = 'Data has been edit successfully';
          this.$modals.open({
              title: 'Updated successfully',
              body: `Data has been edit successfully`
            })

        }else{
          this.$modals.open({
              title: 'Created successfully',
              body: `Data has been added successfully`
            })
        }
        setTimeout(() => {
              this.$modals.close()
              this.closeModal()
              this.resetData();

            }, 3000)
      } catch (error) {
        this.msgType = 'error';
        this.msg = error;
        console.log(error)
        console.log(error.response)
        setTimeout(() => {
          this.msgType = '';
        this.msg = '';
        this.closeModal()
        }, 3000)
      } finally {
        this.isDisabled = false
        setTimeout(() => {
          this.msgType = '';
        this.msg = '';
        this.closeModal()
        }, 3000)
      }
    },
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      setTimeout(() => {
          this.msgType = '';
        this.msg = '';
        }, 100)
      this.$modals.close()
    },
  },
  computed: {
    pageUrls(){
      return this[statisticalStore.getterTypes.GET_APP_ROUTES];
    },
  },
  watch: {
    seo() {
      if (this.$props.seo) {
          this.pageTitle = this.$props.seo.pageTitle;
          this.pageUrl = this.$props.seo.pageUrl;
          this.metaDescription = this.$props.seo.metaDescription;
          this.metaKeywords = this.$props.seo.metaKeywords;
      }
    },
  },
}
</script>
